const PRODUCTS = [
  { name: '콜라 1', price: '500' },
  { name: '콜라 2', price: '1000' },
  { name: '콜라 3', price: '1500' },
  { name: '콜라 4', price: '2000' },
  { name: '콜라 5', price: '2500' },
  { name: '콜라 6', price: '3000' },
  { name: '콜라 7', price: '3500' },
  { name: '콜라 8', price: '4000' },
  { name: '콜라 9', price: '4500' },
  { name: '콜라 10', price: '5000' },
  { name: '콜라 11', price: '5500' },
  { name: '콜라 12', price: '6000' },
  { name: '콜라 13', price: '6500' },
  { name: '콜라 14', price: '7000' },
  { name: '콜라 15', price: '7500' },
  { name: '콜라 16', price: '8000' },
  { name: '콜라 17', price: '8500' },
  { name: '콜라 18', price: '9000' },
  { name: '콜라 19', price: '9500' },
  { name: '콜라 20', price: '10000' },
];

export default PRODUCTS;
